import { render, staticRenderFns } from "./TemplateB.vue?vue&type=template&id=576231f0&scoped=true&"
import script from "./TemplateB.vue?vue&type=script&lang=js&"
export * from "./TemplateB.vue?vue&type=script&lang=js&"
import style0 from "./TemplateB.vue?vue&type=style&index=0&id=576231f0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "576231f0",
  null
  
)

export default component.exports